import { ajax } from 'rxjs/ajax'
import { catchError, map, retry } from 'rxjs/operators'
import { of } from 'rxjs'
import envGet from 'Support/Env/Get/EnvGet.support'
import { ServiceHeadersContentTypeJson } from 'Constants/Service/json-headers'
import HttpService from 'Services/Http/Http.service'
import { Notification } from 'types/Notification'

const BASE_URL_FLITCH = envGet({ key: `REACT_APP_BORAL_BASE_URL_FLITCH` }) as string
const NOTIFICATIONS_URL = envGet({ key: `REACT_APP_BORAL_NOTIFICATIONS_URL` }) as string

interface Options {
  authHeaders: any,
  // httpService: HttpService,
  howMany: number,
  type?: string,
}

export const getNotificationsServiceObservable = (options: Options) => {
  const {
    authHeaders = {},
    // httpService,
    howMany,
    type,
  } = options
  const params = `?${howMany ? `&total=${howMany}` : ``}${type ? `&type=${type}` : ``}`
  const url = `${BASE_URL_FLITCH}${NOTIFICATIONS_URL}${params}`

  return ajax({
    headers: authHeaders,
    url,
  }).pipe(
    map((e) => e.response),
    catchError((error) => of(error)),
  )
}

const getNotificationsService = async (options: Options): Promise<{ notifications: Notification[] }> => {
  return (await getNotificationsServiceObservable(options))
    .pipe()
    .toPromise()
}

export default getNotificationsService
